module.exports = __webpack_public_path__ + "img/timeline-face-4.da34b724.png";